module.exports = __webpack_public_path__ + "c0b08bb98da1d06b570e63b11a05cef1.pdf";